// Serviço para chamar Netlify Functions (backend Node.js)
import { functionsBase } from '../config/functionsBase';

class ApiService {
  constructor() {
    // Em produção, usa URLs relativas do Netlify
    // Em desenvolvimento, usa localhost
    this.baseURL = `${functionsBase(
      process.env.NODE_ENV === 'production'
        ? '/.netlify/functions'
        : 'http://localhost:8891/.netlify/functions'
    )}/server`;
  }

  // Verificar usuário via API
  async verifyUser(discordId, discordUsername) {
    try {
      console.log('🔍 Enviando verificação para API:', discordId, discordUsername);
      
      const response = await fetch(`${this.baseURL}/verifyUser`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          discordId,
          discordUsername
        })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || `Erro na API: ${response.status}`);
      }

      const result = await response.json();
      console.log('✅ Resposta da API:', result);
      
      return result;
    } catch (error) {
      console.error('❌ Erro na chamada da API:', error);
      return {
        success: false,
        error: error.message || 'Erro na comunicação com o servidor'
      };
    }
  }

  // Listar todos os usuários
  async getAllUsers() {
    try {
      console.log('📋 Buscando todos os usuários...');
      
      const response = await fetch(`${this.baseURL}/get-users`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || `Erro na API: ${response.status}`);
      }

      const result = await response.json();
      console.log('✅ Usuários encontrados:', result.total);
      
      return result;
    } catch (error) {
      console.error('❌ Erro ao listar usuários:', error);
      return {
        success: false,
        error: error.message || 'Erro na comunicação com o servidor'
      };
    }
  }

  // Adicionar novo usuário
  async addUser(userData) {
    try {
      console.log('➕ Adicionando usuário:', userData.namedc);
      
      const response = await fetch(`${this.baseURL}/add-user`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(userData)
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || `Erro na API: ${response.status}`);
      }

      const result = await response.json();
      console.log('✅ Usuário adicionado:', result.user.username);
      
      return result;
    } catch (error) {
      console.error('❌ Erro ao adicionar usuário:', error);
      return {
        success: false,
        error: error.message || 'Erro na comunicação com o servidor'
      };
    }
  }

  // Atualizar usuário existente
  async updateUser(discordId, updates) {
    try {
      console.log('🔄 Atualizando usuário:', discordId, updates);
      
      const response = await fetch(`${this.baseURL}/update-user`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          discordId,
          updates
        })
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || `Erro na API: ${response.status}`);
      }

      const result = await response.json();
      console.log('✅ Usuário atualizado:', result.user.username);
      
      return result;
    } catch (error) {
      console.error('❌ Erro ao atualizar usuário:', error);
      return {
        success: false,
        error: error.message || 'Erro na comunicação com o servidor'
      };
    }
  }

  // Testar conexão com a API
  async testConnection() {
    try {
      const response = await fetch(`${this.baseURL}/verifyUser`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          discordId: 'test',
          discordUsername: 'test'
        })
      });

      return {
        success: response.ok,
        status: response.status
      };
    } catch (error) {
      return {
        success: false,
        error: error.message
      };
    }
  }
}

const apiServiceInstance = new ApiService();

export default apiServiceInstance;
